import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import GroupIcon from '@mui/icons-material/Group';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  DialogContentText
} from "@mui/material";

import Draggable from "react-draggable";

import CRUDPageHeader from "../../components/CRUDPageHeader";
import { atualizarCodFornecedor, buscarCodFornecedor, buscarCodFornecedorPorTexto, cadastrarCodFornecedor, deletarCodFornecedor } from "../../services/api-conciliacao.service";
import CodFornecedorForm from "src/forms/CodFornecedorForm";


function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const CodFornecedor = () => {
  const [data, setData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [loading, setLoading] = useState(false)

  const columns = [
    { id: "id_conciliacao_filtro_codigo_fornecedor", label: "ID", field: "id_conciliacao_filtro_codigo_fornecedor" },
    { id: "filtro", label: "Filtro", field: "filtro" },
    { id: "codigo_cliente_fornecedor", label: "Código Cliente Fornecedor", field: "codigo_cliente_fornecedor" },
    { id: "cliente_fornecedor", label: "Cliente Fornecedor", field: "cliente_fornecedor" }
  ];

  useEffect(() => {
    handleAtualizar()
  },[])

  const handleOpenModal = (rowData) => {
    setEditRowData(rowData);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAtualizar = async () => {
    setLoading(true)
    try {
      const response = await buscarCodFornecedor();
      setData(response.filtrosCodigoFornecedor);
      setLoading(false)
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false)
    }
  }

  const handleSaveChanges = async (data) => {

    if (!editRowData.id_conciliacao_filtro_codigo_fornecedor) {
      // Cadastra
      await cadastrarCodFornecedor(data)
        .then(async (response) => {
          setMsg(response.mensagem);
          handleOpenSnackbarSucesso()
          // Buscar dados novamente para renderizar
          handleAtualizar();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      //Atualiza
      await atualizarCodFornecedor(editRowData.id_conciliacao_filtro_codigo_fornecedor, data)
        .then(async (response) => {
          setMsg(response.mensagem);
          // Buscar dados novamente para renderizar
          handleOpenSnackbarSucesso()
          handleAtualizar();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }

    handleCloseModal();
  };

  const handleDelete = async () => {
    //Deleta
    await deletarCodFornecedor(editRowData.id_conciliacao_filtro_codigo_fornecedor)
      .then(async (response) => {
        setMsg(response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso()
        handleAtualizar();
        handleCloseDialogExclusao();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  };


  const handleDebounceChange = async (event) => {
    try {
      const response = await buscarCodFornecedorPorTexto(event.target.value)
      setData(response.filtrosCodigoFornecedor);
    } catch (err) {
      if (err.response?.status === 404) {
        setData([]);
      } else if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
    }
  }


  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };


  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };



  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<>
          <GroupIcon />
        </>}
        headerTitle="Código do Fornecedor"
        modalButtonLabel={"Adicionar"}
        handleOpenModal={handleOpenModal}
      handleDebounceChange={handleDebounceChange}
      />


      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "740px",
            height: "1000vh",
            overflow: "hidden"
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle>
          <div className={styles.tituloPopupContainer}>
            <GroupIcon fontSize="30px" />
            <h1 className={styles.tituloPopup}>Banco Filtro</h1>
          </div>
        </DialogTitle>
        <DialogContent>
          <CodFornecedorForm
            codFornecedorValues={Object.assign({}, editRowData)}
            onClose={handleCloseModal}
            onSubmit={handleSaveChanges}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
          Você realmente deseja excluir permanentemente o código de fornecedor{" "}
            "{editRowData.codigo_cliente_fornecedor}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default CodFornecedor;
